import React from "react";
import Radio from "@source/components/UI/buttons/radio/radio";
import TextInput from "@source/components/UI/inputs/textInput/textInput";
import {
  clinicalVerificationMethods,
  IdentityVerificationDetail,
  photoIdTypeOptions,
} from "@source/api/models/consentHelpers";
import {ConsentClinicalIdentityVerificationMethod, ConsentPhotoIdType} from "@source/api/models/consentModels";
import styles from "./identityVerificationChoices.module.scss";

export const IdentityVerificationChoices = ({
  signerName,
  method,
  detail,
  disabled,
  onMethod,
  onDetail,
}: {
  signerName: string;
  method?: ConsentClinicalIdentityVerificationMethod;
  detail: IdentityVerificationDetail;
  disabled: boolean;
  onMethod: (method: ConsentClinicalIdentityVerificationMethod) => void;
  onDetail: (detail: IdentityVerificationDetail) => void;
}) => (
  <>
    <p className={styles.statement}>I confirm I am with {signerName || "[Signer Name]"} and have verified their identity in person by (please select one of the 3 options below):</p>
    <div className={styles.methods}>
      {clinicalVerificationMethods.map((option) => <div key={option.value}>
        <Radio name="identity-verification-method" value={option.value} checked={method === option.value} disabled={disabled} onChange={() => onMethod(option.value)} label={option.label}/>
        {method === option.value && option.value === ConsentClinicalIdentityVerificationMethod.PHOTO_ID ? <div className={styles.detail}>
          <span>Please tick which ID you sighted</span>
          {photoIdTypeOptions.map((photo, index) => <React.Fragment key={photo.value}>
            {index > 0 ? <span className={styles.or}>or</span> : null}
            <Radio name="identity-photo-id" value={photo.value} checked={detail.photoIdType === photo.value} disabled={disabled} onChange={() => onDetail({photoIdType: photo.value as ConsentPhotoIdType})} label={photo.label}/>
          </React.Fragment>)}
        </div> : null}
        {method === option.value && option.value === ConsentClinicalIdentityVerificationMethod.PROFESSIONAL_REGISTRATION ? <div className={styles.detail}>
          <TextInput id="identity-professional-registration" label="Please write which professional registration you sighted" value={detail.professionalRegistration || ""} handleChange={(event) => onDetail({professionalRegistration: event.target.value.slice(0, 200)})} disabled={disabled} required/>
        </div> : null}
      </div>)}
    </div>
  </>
);
